import { render, staticRenderFns } from "./edit-new-year-activity.vue?vue&type=template&id=49deb875&scoped=true&"
import script from "./edit-new-year-activity.vue?vue&type=script&lang=js&"
export * from "./edit-new-year-activity.vue?vue&type=script&lang=js&"
import style0 from "./edit-new-year-activity.vue?vue&type=style&index=0&id=49deb875&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49deb875",
  null
  
)

export default component.exports